"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var store = _interopRequireWildcard(require("@/api/product"));
var _permission = require("@/utils/permission");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  data: function data() {
    var _this = this;
    var validateGuarantee = function validateGuarantee(rule, value, callback) {
      if (_this.guaranteeChanged.length === 0) {
        callback(new Error('请至少选择一个服务选项'));
      } else {
        callback();
      }
    };
    return {
      listLoading: false,
      keyNum: 0,
      dialogVisible: false,
      guaranteeForm: {
        name: '',
        id: 0,
        gids: ''
      },
      guaranteeList: [],
      guaranteeListNew: [],
      tableData: {
        data: []
      },
      rules: {
        name: [{
          required: true,
          message: '请填写组合名称',
          trigger: 'blur'
        }],
        guaranteeList: [{
          required: true,
          validator: validateGuarantee,
          trigger: 'change'
        }]
      },
      guaranteeChanged: [],
      isDisabled: false
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:product:guarantee:group:list'])) this.getList();
    if ((0, _permission.checkPermi)(['merchant:plat:product:guarantee:list'])) this.getProductGuarantee();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    selectable: function selectable(row, index) {
      if (this.isDisabled) return false;
      if (row.isShow) {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.guaranteeChanged = val;
    },
    // 保障服务列表
    getProductGuarantee: function getProductGuarantee() {
      var _this2 = this;
      store.productGuaranteeApi().then(function (res) {
        _this2.guaranteeList = res;
      });
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.guaranteeForm = {
        name: '',
        id: 0,
        gids: ''
      };
      this.guaranteeChanged = [];
      this.$refs.multipleTable.clearSelection();
      this.$refs['guaranteeForm'].resetFields();
    },
    // 列表
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      store.guaranteeListApi().then(function (res) {
        _this3.tableData.data = res;
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    handlerOpenEdit: function handlerOpenEdit(isCreate, editDate, info) {
      var _this4 = this;
      var list = [];
      this.guaranteeListNew = _toConsumableArray(this.guaranteeList);
      this.isDisabled = !!info;
      if (isCreate === 1) {
        this.guaranteeForm = Object.assign({}, editDate);
        this.guaranteeListNew.map(function (item) {
          editDate.guaranteeList.map(function (obj) {
            if (obj.gid === item.id && obj.isShow) list.push(item);
          });
        });
        if (list) {
          list.forEach(function (row) {
            _this4.$nextTick(function () {
              _this4.$refs.multipleTable.toggleRowSelection(row, true);
            });
          });
        }
      } else {
        list = this.guaranteeListNew.filter(function (item) {
          return item.isShow;
        });
        this.guaranteeListNew = list;
      }
      this.dialogVisible = true;
    },
    close: function close() {
      this.dialogVisible = false;
      this.guaranteeForm.name = '';
      this.getList();
    },
    submitForm: function submitForm(formName) {
      var _this5 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var ids = [];
          _this5.guaranteeChanged.map(function (item) {
            ids.push(item.id);
          });
          _this5.$delete(_this5.guaranteeForm, 'guaranteeList');
          _this5.$delete(_this5.guaranteeForm, 'createTime');
          _this5.guaranteeForm.gids = ids.toString();
          !_this5.guaranteeForm.id ? store.guaranteeAddApi(_this5.guaranteeForm).then(function (res) {
            _this5.$message.success('操作成功');
            _this5.close();
          }).catch(function () {
            _this5.loading = false;
          }) : store.guaranteeUpdateApi(_this5.guaranteeForm).then(function (res) {
            _this5.$message.success('操作成功');
            _this5.close();
          }).catch(function () {
            _this5.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handlerOpenDel: function handlerOpenDel(rowData) {
      var _this6 = this;
      this.$modalSure('删除当前保障服务吗').then(function () {
        store.guaranteeDeleteApi(rowData.id).then(function (data) {
          _this6.$message.success('删除成功');
          _this6.getList();
        });
      });
    }
  }
};